import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Circle } from "lucide-react";

interface IFurnaceVentCapCollar {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function FurnaceVentCapCollar(props: IFurnaceVentCapCollar) {
    const { value, onChange, loading } = { ...props };
    const [capCollar, setCapCollar] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setCapCollar(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setCapCollar(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Cap and Collar
            </Typography>

            <Select
                placeholder="Select cap and collar size"
                value={capCollar}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Circle size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="4 inch">4 inch</Option>
                <Option value="5 inch">5 inch</Option>
                <Option value="6 inch">6 inch</Option>
                <Option value="7 inch">7 inch</Option>
                <Option value="TBD">TBD</Option>
            </Select>
        </Box>
    );
}
